// extracted by mini-css-extract-plugin
export var header = "_fh-0";